import {
  House, Lightning, ChatCircleDots, ClockCounterClockwise, ChartBar, FileText,
  Compass, PaperPlaneTilt, CalendarBlank, CalendarCheck,
} from "@phosphor-icons/react";

// Primary nav — the daily loop: plan → brief → create → approve → review.
// Every content builder lives inside the /create hub, not the nav bar.
export const PRIMARY_NAV = [
  { path: "/dashboard", label: "Home", icon: House },
  { path: "/chat", label: "Chat", icon: ChatCircleDots },
  { path: "/create", label: "Create", icon: Lightning },
  { path: "/briefs", label: "Briefs", icon: Compass },
  { path: "/plans", label: "Plans", icon: CalendarCheck },
  { path: "/approvals", label: "Approvals", icon: PaperPlaneTilt },
  { path: "/history", label: "History", icon: ClockCounterClockwise },
];

// Secondary nav — useful but not daily. Everything else is inside /create.
export const SECONDARY_NAV = [
  { path: "/calendar", label: "Calendar", icon: CalendarBlank },
  { path: "/insights", label: "Insights", icon: ChartBar },
  { path: "/reports", label: "Reports", icon: FileText },
];

export const GATED_FEATURES = {
  "/briefs": "brief_builder",
  "/calendar": "content_calendar",
  "/insights": "insights_dashboard",
  "/approvals": "client_approval_portal",
  "/plans": "content_planner",
  "/reports": "report_builder",
  "/settings/personalization/voice-wizard": "brand_voice_wizard",
  "/settings/personalization/voice-history": "brand_voice_wizard",
};

const TIER_FEATURES = {
  free_beta: ["content_builders", "basic_brand_voice", "content_history", "basic_repurpose"],
  creator: ["content_builders", "basic_brand_voice", "content_history", "basic_repurpose", "brand_voice_wizard", "brief_builder", "content_calendar", "status_workflow", "per_section_regenerate", "draft_autosave", "error_recovery"],
  studio: ["all_creator_features", "content_planner", "client_approval_portal", "report_builder", "insights_dashboard", "client_viewer_role"],
  agency: ["all"],
  enterprise: ["all"],
};

export function isNavLocked(path, tier, isAdmin) {
  if (isAdmin) return false;
  const feature = GATED_FEATURES[path];
  if (!feature) return false;
  const tierFeats = TIER_FEATURES[tier] || TIER_FEATURES.free_beta;
  if (tierFeats.includes("all")) return false;
  if (tierFeats.includes("all_creator_features") && TIER_FEATURES.creator.includes(feature)) return false;
  return !tierFeats.includes(feature);
}
